module.exports = __webpack_public_path__ + "img/shape_tracerstudy_download.8ca43f6e.svg";